// extracted by mini-css-extract-plugin
module.exports = {"container":"ApplyCtaSection_container__tKcW3","title":"ApplyCtaSection_title__R4d_l","text":"ApplyCtaSection_text__EZJCL","ctaWrapper":"ApplyCtaSection_ctaWrapper__PjDuM"};